export type Breaker = {
  powerPack: string;
  inputPower: number;
  toolDiameter: number;
};

export enum BoomFamily {
  SMALL_SERIES = 'small series',
  MEDIUM_SERIES = 'medium series',
  LARGE_SERIES = 'large series',
  EXTRA_LARGE_SERIES = 'extra large series',
}

export type Boom = {
  verticalReach: number;
  horizontalReach: number;
  swing: number;
  family: BoomFamily;
};

export interface BreakerUnitInfoDataInterface {
  breakers: Record<string, Breaker>;
  booms: Record<string, Boom>;
}

export enum BreakerApplication {
  JAW_CRUSHER = 'jawCrusher',
  GYRATORY = 'gyratoryCrusher',
  STATIONARY_GRIZZLY = 'stationaryGrizzly',
}
